import type { RuleHandler } from "../types";

const checkMaximumSelections: RuleHandler = (context, requirement) => {
  const maxSelectionCount =
    requirement.userDrivenAttributes?.maximumSelections ?? 0;

  if (maxSelectionCount < context.selection.outcomeIds?.length) {
    return false;
  }

  if (maxSelectionCount === 1 && context.selection.isMulti) {
    return false;
  }

  return true;
};

export { checkMaximumSelections };
